module.exports = __webpack_public_path__ + "static/media/doc.1a4941f4.svg";